<template>
  <div>
    <b-button id="show-btn" size="sm" @click="showModal">
      <i id="icon-resequence" class="tim-icons" />
      <!-- <img src="/img/icons/rms/resequence.png" width="15px" height="15px" alt="submit" /> -->
    </b-button>
    <b-modal ref="my-modal" hide-footer title="Alteração de ID">
      <div class="d-block">
        <h3>{{ displayName }}</h3>
        <div>
          <label>ID Atual</label>
        </div>
        <div>
          <label>{{ item.sequenceNumber }}</label>
        </div>

        <b-form-group label="Novo ID" label-for="id-novo">
          <b-form-input
            id="id-novo"
            type="text"
            placeholder="Novo ID"
            v-model="newSequenceNumber"
            v-mask="'99999999'"
          />
        </b-form-group>
      </div>
      <b-button class="mt-3" block @click="confirm"> Confirmar </b-button>
      <b-button class="mt-3" variant="danger" block @click="hideModal">
        Cancelar
      </b-button>
      <!-- <div>{{item}}</div> -->
      <!-- <div>{{items}}</div> -->
    </b-modal>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import FormSequenceControl from "./MenuSequenceControl";

export default {
  name: "TableMenuResequence",
  props: {
    item: Object,
    items: Array,
    displayName: Number,
  },
  data() {
    return {
      newSequenceNumber: 0,
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  mixins: [FormSequenceControl],
  mounted() {
    if (this.item) {
      this.newSequenceNumber = this.item.sequenceNumber;
    } else {
      this.newSequenceNumber = 0;
    }
  },
  methods: {
    confirm() {
      this.setSequenceNumber(this.items, this.item, this.newSequenceNumber);
      this.hideModal();
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
  },
  watch: {
    item() {
      if (this.item) {
        this.newSequenceNumber = this.item.sequenceNumber;
      } else {
        this.newSequenceNumber = 0;
      }
    },
  },
};
</script>

<style  scoped>
#icon-resequence {
  content: url(/img/icons/rms/resequence.png);
  -webkit-filter: invert(100%); /* Safari/Chrome */
  filter: invert(100%);
}
</style>